import React, { PureComponent } from 'react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

const colors = ['#000', '#82ca9d']

export default function LineChartComponent({
  data = [],
  indicator = '',
  stageOne,
  xDataKey = 'indicator',
  yDataKey = 'average',
  xAngle = 0,
}) {
  return (
    <div width="100%" height="100vh" style={{ overflow: 'auto' }}>
      {/* {JSON.stringify(data)} */}
      <LineChart
        width={900}
        height={380}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 50,
          bottom: 60,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xDataKey} angle={xAngle} textAnchor="end" />
        <YAxis />
        <Tooltip />
        <Legend />
        {/* <Line
          type="monotone"
        //   dataKey="pv"
          stroke="#8884d8"
          activeDot={{ r: 8 }}
        /> */}
        {indicator.map((ind, i) => (
          <Line
            type="monotone"
            dataKey={yDataKey}
            stroke="#8884d8"
            fill="#8884d8"
            line={false}
          />
        ))}
      </LineChart>
    </div>
  )
}
